module.exports = __webpack_public_path__ + "static/media/doctor-thumb-10.0da74a38.jpg";